import * as snackBar from './snackbar/snackbar.reducer';
import * as auth from './auth/auth.reducer';
import * as loadingSpinner from './loading-spinner/loading-spinner.reducer';
import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './store.states';

export const reducers: ActionReducerMap<AppState> = {
  auth: auth.reducer,
  snackBar: snackBar.reducer,
  loadingSpinner: loadingSpinner.reducer,
};
